module.exports = __webpack_public_path__ + "img/info5-bg.4a8e7f08.svg";